// extracted by mini-css-extract-plugin
export default {"textEntry":"TextEntry_textEntry__kGRzJ"};